import { useCallback } from 'react'

import { useCreateOnboardingTipsMutation } from 'api/onboardingTips/mutations'
import { useOnboardingTipsDataQuery } from 'api/onboardingTips/queries'
import { addNewUserTipsQueryClient } from 'api/onboardingTips/setters'
import { OnboardingTip } from 'types/Api'

export const useOnboardingTooltip = (slug: OnboardingTip['slug']) => {
  const { mutate: updateUserTipsMutation } = useCreateOnboardingTipsMutation()

  const { data: onBoardingTipsData } = useOnboardingTipsDataQuery()

  const isOnboardingTooltipActive
    = Boolean(onBoardingTipsData?.onboardingTips.find(item => item.slug === slug))

  const handleDismissOnboardingTooltip = useCallback(() => {
    addNewUserTipsQueryClient({
      slug,
    })

    updateUserTipsMutation({
      dismissed: true,
      slug,
    })
  }, [slug, updateUserTipsMutation])

  return {
    isOnboardingTooltipActive,
    onDismissOnboardingTooltip: handleDismissOnboardingTooltip,
  }
}
